import React from 'react'
import { Alert } from 'react-bootstrap'
import cn from 'classnames'

import { SearchResultType } from '@monorepo/interfaces'
import { ResultItem } from './ResultItem'
import style from './style.module.scss'

type PropsType = {
  items: Array<SearchResultType>
  title: React.ReactNode
}

export const ResultsList: React.FC<PropsType> = ({ items, title }) => (
  <>
    <Alert variant="secondary">
      <strong className="text-uppercase">{title}</strong> [{items.length}{' '}
      предложений]
    </Alert>
    <div
      className={cn(
        'products-view__list',
        'products-list',
        'products-list--grid--4',
        style.container
      )}
      data-layout="table"
      data-with-features="false"
    >
      <div className="products-list__head d-none d-xl-flex">
        <div className="products-list__column products-list__column--image"></div>
        <div className="products-list__column products-list__column--meta text-left">
          Бренд
        </div>
        <div className="products-list__column products-list__column--product text-right">
          Артикул
        </div>
        <div className="products-list__column products-list__column--price">
          Наличие
        </div>
        <div className="products-list__column products-list__column--price">
          Срок|Склад
        </div>
        <div className="products-list__column products-list__column--price">
          Цена
        </div>
      </div>
      <div className="products-list__content">
        {items.map((item) => (
          <ResultItem key={item.good.id} item={item} />
        ))}
      </div>
    </div>
  </>
)
